import { __decorate } from "tslib";
import { Component, Input, ViewChild, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownModule } from 'primeng/dropdown';
import { ReactiveFormsModule } from '@angular/forms';
import { OrganizationService } from '../../shared/services/organization.service';
import { Subject, takeUntil, tap } from 'rxjs';
let OrganizationsComponent = class OrganizationsComponent {
    inputId;
    control;
    readonly = false;
    disabled = false;
    pDrop;
    organizations;
    organizationService = inject(OrganizationService);
    unsubscribe$ = new Subject();
    ngOnInit() {
        this.organizationService
            .getOrganizations()
            .pipe(takeUntil(this.unsubscribe$), tap((data) => {
            this.organizations =
                data?.array?.sort((a, b) => a.name.localeCompare(b.name));
        }))
            .subscribe();
    }
    ngAfterViewInit() {
        this.pDrop.setDisabledState(Boolean(this.disabled));
    }
    ngOnChanges(changes) {
        if (this.pDrop && changes.disabled) {
            this.pDrop.setDisabledState(Boolean(this.disabled));
        }
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
    static propDecorators = {
        inputId: [{ type: Input }],
        control: [{ type: Input }],
        readonly: [{ type: Input }],
        disabled: [{ type: Input }],
        pDrop: [{ type: ViewChild, args: ['pDrop',] }]
    };
};
OrganizationsComponent = __decorate([
    Component({
        selector: 'organizations',
        template: `
    <div *ngIf="control">
        <p-dropdown
          #pDrop
          [inputId]="inputId"
          appendTo="body"
          [options]="organizations"
          [formControl]="control"
          optionLabel="name"
          optionValue="id"
          [filter]="true"
          filterBy="name"
          [showClear]="!readonly"
          [readonly]="readonly"
          placeholder="Select Organization"
        >
          <ng-template let-org pTemplate="item">
            <div class="flex align-items-center gap-2">
              <div>{{ org.name }}</div>
            </div>
          </ng-template>
        </p-dropdown>
    </div>
  `,
        imports: [CommonModule, DropdownModule, ReactiveFormsModule],
        standalone: true,
    })
], OrganizationsComponent);
export { OrganizationsComponent };
